export default __webpack_public_path__ + "static/media/shopping.0415469d.svg";